import { TAG } from "../constants";
import { PatientOrder, ProductBillingModel } from "../types";
import { patientApi } from "./patientApi";

export const orderApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrders: builder.query<
      PatientOrder[],
      void | { page?: string; product_id?: number }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/patient/orders`,
        params: {
          page: params?.page ?? undefined,
          product_id: params?.product_id ?? undefined,
        },
      }),
      providesTags: [TAG.ORDERS],
    }),
    getLatestOrder: builder.query<
      PatientOrder,
      void | {
        productId?: number;
        billing_model?: ProductBillingModel;
        category?: string;
      }
    >({
      query: (params) => ({
        url: `/api/patient/orders/latest`,
        method: "GET",
        params: {
          product_id: params?.productId ?? undefined,
          billing_model: params?.billing_model ?? undefined,
          category: params?.category ?? undefined,
        },
      }),
      providesTags: [TAG.LATEST_ORDER],
    }),
    getLatestOTWeightLossOrder: builder.query<PatientOrder, void>({
      query: () => ({
        url: `/api/patient/orders/latest/ot-weight-loss`,
        method: "GET",
      }),
      providesTags: [TAG.LATEST_ORDER],
    }),
  }),
});

export const {
  useGetLatestOrderQuery,
  useGetLatestOTWeightLossOrderQuery,
  useGetOrdersQuery,
} = orderApi;
